import { useState } from 'react';

import { Button, Stack, TextField, Typography, Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';
import Calendar from 'common/DatePicker';
import { arrayMoveImmutable } from 'array-move'
import SortableList, { SortableItem, SortableKnob } from 'react-easy-sort';

import { TitlesWrapper, VisibleWrapper, StyledFormHelperText } from './styled';
import { useCreateBlogLogic } from './useCreateBlogLogic';
import MultipleFormContent from './components/MultipleFormContent';
import { makeContentInitData } from './data';
import { blogFirstKey } from './constant';
import { IBlogContent } from './types';

const CreateBlog = () => {
  const {
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    isDeleteModalOpen,
    largeImageMessage,
    blogContent,
    setValue,
    setFlowProcess,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
  } = useCreateBlogLogic();

  const onSortEnd = (oldIndex: number, newIndex: number) => {
    const clone = JSON.parse(JSON.stringify(blogContent)) as IBlogContent[]

    setValue(blogFirstKey, arrayMoveImmutable(clone, oldIndex, newIndex))
  }

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Blog' : 'Create New Blog'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('titleAm')}
            label="Title Am"
            error={!!errors.titleAm}
            helperText={errors.titleAm ? 'Title is required' : ''}
          />
          <TextField
            {...register('titleEn')}
            label="Title En"
            error={!!errors.titleEn}
            helperText={errors.titleEn ? 'Title is required' : ''}
          />

          <TextField
            {...register('titleRu')}
            label="Title Ru"
            error={!!errors.titleRu}
            helperText={errors.titleRu ? 'Title is required' : ''}
          />
        </TitlesWrapper>

        {/* <SortableList
          onSortEnd={onSortEnd}
          lockAxis="y"
          draggedItemClassName="dragged"
        > */}
        {
            blogContent?.map((field, index) => {
              return (
              // <SortableItem
              //   key={field?.id || JSON.stringify(field) + index}
              // >
              //   <div>
                <MultipleFormContent
                  id={field?.id}
                  index={index}
                  key={field?.id || JSON.stringify(field) + index}
                  isImageViewOpen={isImageViewOpen}
                  imageSrcForAction={imageSrcForAction}
                  isDeleteModalOpen={isDeleteModalOpen}
                  contentLength={blogContent.length}
                  setFlowProcess={setFlowProcess}
                  onChangeUpload={onChangeUpload}
                />
              //   </div>
              // </SortableItem>
              )
            })
          }
        {/* </SortableList> */}

        <Button
          sx={{ mt: 1, maxWidth: '300px' }}
          type="button"
          color="primary"
          variant="contained"
          disabled={isButtonLoading}
          onClick={() => {
            setValue(blogFirstKey, [...blogContent, makeContentInitData()])
          }}
        >
          One more content
        </Button>

        <VisibleWrapper>
          <Box>
            <Typography>
              Visibility in website
            </Typography>
            <Box>
              <Radio label="Yes" name="visible" canBe />
              <Radio label="No" name="visible" canBe={false} />
            </Box>
          </Box>
          <Box>
            <Calendar name="postedDate" label="Posted Date" />
          </Box>
          <Box>
            <TextField
              type="number"
              {...register('minRead')}
              label="Read Minutes"
              error={!!errors.minRead}
              helperText={errors.minRead ? 'Minute is required' : ''}
            />
          </Box>
        </VisibleWrapper>

        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          Submit
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default CreateBlog;
